export default __webpack_public_path__ + "media/zurb/img/home/hulu-press-93595651c7f0c0ea6a7d16e46226a514.png";